<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-gray py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Bem-vindo!</h1>
              <p class="text-lead text-white">
                Entre para visualizar suas peças cadastradas.
                <br />
                Ainda não se cadastrou?
                <router-link to="/cadastro" class="text-white font-weight-bold"
                  >Registre-se aqui.</router-link
                >
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-darker" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-md-8">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    v-model="model.email"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Senha"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Senha"
                    v-model="model.password"
                  >
                  </base-input>

                  <!-- <b-form-checkbox v-model="model.rememberMe">Mantenha conectado</b-form-checkbox> -->
                  <div class="text-center text-danger">
                    {{ errorFeedback }}
                  </div>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      :loading="loading"
                      class="my-4"
                      >Entrar</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <!-- <router-link to="/dashboard" class="text-light"><small>Esqueceu sua senha?</small></router-link> -->
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/cadastro" class="text-light"
                ><small>Ainda não é cadastrado?</small></router-link
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { login } from "@/services/utils";

export default {
  data() {
    return {
      errorFeedback: "",
      loading: false,
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    login,
    setLoading(loading) {
      this.loading = loading;
    },
    successLogin() {
      this.$router.push("/usuario");
    },
    errorLogin() {
      this.errorFeedback =
        "Não é possível fazer login. Verifique seu e-mail e senha.";
    },
    async onSubmit() {
      this.errorFeedback = "";
      login(
        this.model.email,
        this.model.password,
        this.setLoading,
        this.successLogin,
        this.errorLogin
      );
    },
  },
};
</script>
